import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/wug-torino-2025.svg'
import _imports_1 from '@/assets/images/3bmeteo.svg'


const _hoisted_1 = { class: "login d-flex flex-column bg-linear-4C2C7C-00A8DF h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "ma-0 pa-0 pt-2 bg-blue-lighten-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          "scroll-behavior": "elevate",
          class: "d-flex justify-space-between ma-0 px-sm-25 pt-2 pb-4 pb bg-indigo-darken-3"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "w-100px w-sm-150px"
            }, null, -1),
            _createElementVNode("img", {
              src: _imports_1,
              class: "w-100px w-sm-150px"
            }, null, -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "flex-1-0-0 d-flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "my-auto px-0 px-sm-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "mb-8 px-0 px-sm-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { class: "pa-0 text-white text-center text-subtitle-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.heading.subtitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_container, { class: "pa-0 text-white text-center text-h3 font-weight-medium" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.heading.title')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, { class: "w-sm-50 bg-white mx-auto py-8 px-1 px-sm-6 d-flex flex-column rounded-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { class: "text-center text-h5 font-weight-medium" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.form.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_form, {
                  ref: "form",
                  class: "",
                  "validate-on": "submit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.email.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email.value) = $event)),
                          label: _ctx.$t('login.form.email.label'),
                          hint: _ctx.$t('login.form.email.hint'),
                          "persistent-hint": "",
                          variant: "outlined",
                          class: "mb-5 text-grey-darken-1",
                          color: "indigo",
                          rules: _ctx.email.rules
                        }, null, 8, ["modelValue", "label", "hint", "rules"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.password.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.value) = $event)),
                          label: _ctx.$t('login.form.password.label'),
                          hint: _ctx.$t('login.form.password.hint'),
                          "persistent-hint": "",
                          variant: "outlined",
                          class: "mb-5 text-grey-darken-1",
                          color: "indigo",
                          rules: _ctx.password.rules,
                          type: _ctx.password.show ? 'text' : 'password',
                          "append-icon": _ctx.password.show ? 'mdi-eye' : 'mdi-eye-off',
                          "onClick:append": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password.show = !_ctx.password.show))
                        }, null, 8, ["modelValue", "label", "hint", "rules", "type", "append-icon"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.rememberMe,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rememberMe) = $event)),
                          "hide-details": "",
                          label: "Ricordami",
                          color: "blue-grey-darken-1"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "mx-auto bg-blue-darken-3 text-white text-body-1 rounded-lg",
                  onClick: _ctx.login
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.form.submit')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, {
      fluid: "",
      height: "100",
      class: "bg-indigo-darken-3"
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar.opened,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.snackbar.opened) = $event)),
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`snackbar.${ _ctx.snackbar.message }`)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}